import React from 'react'

import { number, string } from 'prop-types'

import LinkedPagination from 'Pods/Shared/LinkedPagination/LinkedPagination'

function BlogPagination({
  currentPage,
  totalPages,
  currentPath,
}) {
  if ((Number(totalPages) || 1) === 1) {
    return null
  }

  return (
    <div className="container-fixed">
      <div className="row">
        <div className="col-12">
          <LinkedPagination currentPage={currentPage} totalPages={totalPages} currentPath={currentPath} />
        </div>
      </div>
    </div>
  )
}

BlogPagination.propTypes = {
  currentPage: number.isRequired,
  totalPages: number.isRequired,
  currentPath: string.isRequired,
}

export default BlogPagination
